import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const MyDatePicker = ({ data, setAnswer }) => {
  const onChange = (date, dateString) => {
    setAnswer(dateString);
  };

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-start gap-2">
        {data?.is_required === 1 && <p className="text-red-600 text-lg">*</p>}
        <p className="text-base text-center">{data?.field_label}</p>
      </div>
      
      <DatePicker
        size="large"
        className="w-full py-3 ps-4"
        format="YYYY-MM-DD"
        placeholder="YYYY-MM-DD"
        defaultValue={data?.response_text ? dayjs(data?.response_text) : null}
        onChange={onChange}
      />
    </div>
  );
};

export default MyDatePicker;
